'use client';

import React from 'react';
import { useSnapshot } from 'valtio';
import { pageLoadingStore } from '@/stores/pageLoadingStore';

interface HeroButtonWrapperProps {
  children: React.ReactNode;
  className?: string;
}

const HeroButtonWrapper = ({ children, className = '' }: HeroButtonWrapperProps) => {
  const snap = useSnapshot(pageLoadingStore);

  const heroButtonClass = snap.isHeroButtonReady ? 'hero-button-loaded' : 'hero-button-loading';

  return (
    <div className={`${heroButtonClass} ${className}`}>
      {children}
    </div>
  );
};

export default HeroButtonWrapper;
